import { render } from "./Events.vue?vue&type=template&id=35eecec0"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
script.render = render

export default script